import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const EMPTY = { title: "", excerpt: "", content: "", cover_image: "", tags: "", published: true };
const input = "w-full bg-surface border border-gold/20 rounded-xl px-4 py-2.5 text-cream placeholder:text-faded focus:outline-none focus:ring-1 focus:ring-gold text-sm";

export default function AdminBlog() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState(EMPTY);
    const [editId, setEditId] = useState(null);

    const load = () => api.get("/admin/blog").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const save = async (e) => {
        e.preventDefault();
        const payload = { ...form, tags: form.tags.split(",").map((t) => t.trim()).filter(Boolean) };
        try {
            if (editId) await api.put(`/admin/blog/${editId}`, payload);
            else await api.post("/admin/blog", payload);
            toast.success("Saved"); setOpen(false); setForm(EMPTY); setEditId(null); load();
        } catch { toast.error("Could not save"); }
    };
    const del = async (id) => { if (!window.confirm("Delete this post?")) return; await api.delete(`/admin/blog/${id}`); toast.success("Deleted"); load(); };

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <h1 className="font-serif text-4xl text-cream">Journal</h1>
                <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) { setForm(EMPTY); setEditId(null); } }}>
                    <DialogTrigger asChild>
                        <button data-testid="add-post-btn" className="inline-flex items-center gap-2 bg-gold text-ink rounded-full px-5 py-2.5 text-sm font-medium hover:bg-goldbright"><Plus className="w-4 h-4" /> New Post</button>
                    </DialogTrigger>
                    <DialogContent className="bg-surface2 border-gold/20 text-cream max-w-xl max-h-[90vh] overflow-y-auto">
                        <DialogHeader><DialogTitle className="font-serif text-2xl">{editId ? "Edit" : "New"} Post</DialogTitle></DialogHeader>
                        <form onSubmit={save} className="space-y-3">
                            <input required placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className={input} />
                            <input placeholder="Cover image URL" value={form.cover_image} onChange={(e) => setForm({ ...form, cover_image: e.target.value })} className={input} />
                            <input placeholder="Tags (comma separated)" value={Array.isArray(form.tags) ? form.tags.join(", ") : form.tags} onChange={(e) => setForm({ ...form, tags: e.target.value })} className={input} />
                            <textarea rows={2} placeholder="Excerpt" value={form.excerpt} onChange={(e) => setForm({ ...form, excerpt: e.target.value })} className={input} />
                            <textarea rows={8} placeholder="Content" value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} className={input} />
                            <label className="flex items-center gap-2 text-sm text-ash"><input type="checkbox" checked={form.published} onChange={(e) => setForm({ ...form, published: e.target.checked })} className="accent-gold" /> Published</label>
                            <button className="w-full bg-gold text-ink rounded-full py-2.5 font-medium">Save Post</button>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>
            <div className="space-y-3">
                {items.map((p) => (
                    <div key={p.id} className="p-4 rounded-xl bg-surface border border-gold/10 flex items-center gap-4">
                        <img src={p.cover_image} alt="" className="w-16 h-12 rounded object-cover" />
                        <div className="flex-1">
                            <div className="text-cream">{p.title}</div>
                            <div className="text-xs text-faded">{p.published ? "Published" : "Draft"} · {(p.tags || []).join(", ")}</div>
                        </div>
                        <button onClick={() => { setForm({ ...p, tags: (p.tags || []).join(", ") }); setEditId(p.id); setOpen(true); }} className="text-ash hover:text-gold"><Pencil className="w-4 h-4" /></button>
                        <button onClick={() => del(p.id)} className="text-ash hover:text-clay"><Trash2 className="w-4 h-4" /></button>
                    </div>
                ))}
            </div>
        </div>
    );
}
